import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthConfig, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { SignedOutComponent } from './components/signed-out/signed-out.component';
import { UserComponent } from './components/user/user.component';
import { StatehandlerProcessorService, StatehandlerProcessorServiceImpl } from './services/statehandler-processor.service';
import { StatehandlerService, StatehandlerServiceImpl } from './services/statehandler.service';
import { StorageService } from './services/storage.service';

// const authConfig: AuthConfig = {
//   scope: 'openid profile email offline_access',
//   responseType: 'code',
//   oidc: true,
//   clientId: '311851266877785330',
//   issuer: 'https://spc-nexus-dev-xkrkf3.us1.zitadel.cloud', // eg. https://acme-jdo9fs.zitadel.cloud
//   redirectUri: 'http://localhost:4200/auth/callback',
//   postLogoutRedirectUri: 'http://localhost:4200/signedout',
//   requireHttps: false, // required for running locally
// };


const authConfig: AuthConfig = {
  // scope: 'openid profile email offline_access',
  scope: 'openid profile email',
  responseType: 'code',
  oidc: true,
  clientId: 'zitadel-demo',
  issuer: 'https://account.onspc.com/realms/SPC', // http://127.0.0.1:8080/realms/SPC-dev
  redirectUri: 'https://sso-demo.prod.spc.es/auth/callback',
  postLogoutRedirectUri: 'https://sso-demo.prod.spc.es/signedout',
  requireHttps: true, // required for running locally
};

const stateHandlerFn = (stateHandler: StatehandlerService) => {
  return () => {
    return stateHandler.initStateHandler();
  };
};

@NgModule({ declarations: [AppComponent, SignedOutComponent, UserComponent, HomeComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: ['https://spc-nexus-dev-xkrkf3.us1.zitadel.cloud/admin/v1', 'https://spc-nexus-dev-xkrkf3.us1.zitadel.cloud/management/v1', 'https://spc-nexus-dev-xkrkf3.us1.zitadel.cloud/auth/v1/'],
                sendAccessToken: true,
            },
        })], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: stateHandlerFn,
            multi: true,
            deps: [StatehandlerService],
        },
        {
            provide: AuthConfig,
            useValue: authConfig,
        },
        {
            provide: StatehandlerProcessorService,
            useClass: StatehandlerProcessorServiceImpl,
        },
        {
            provide: StatehandlerService,
            useClass: StatehandlerServiceImpl,
        },
        {
            provide: OAuthStorage,
            useClass: StorageService,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
